import constants from 'constants/index'

const {
  PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_1,
  PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_2,
  PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_TABS,
} = constants.privacyByDesign

const generalInfoStep = {
  element: '#' + PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_1,
  popover: {
    title: 'Informações gerais',
    description:
      'Preencha o nome, o responsável e a finalidade do projeto. O departamento é o seu, e o questionário escolhido define as questões que serão respondidas.',
  },
}

// As questões só existem depois de o projeto ser criado, então na criação o tour
// tem apenas o passo das informações gerais — um passo sem elemento na tela faz
// o driver abrir o popover solto, sem destacar nada.
const questionsSteps = [
  {
    element: '#' + PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_TABS,
    popover: {
      title: 'Abas de status',
      description:
        'Use as abas para ver todas as questões, apenas as pendentes ou apenas as já respondidas.',
    },
  },
  {
    element: '#' + PRIVACY_BY_DESIGN_FORM_DRIVER_STEP_2,
    popover: {
      title: 'Questões do projeto',
      description:
        'Responda as questões uma a uma: marque a alternativa e clique em Salvar. Algumas alternativas exigem justificativa e evidência anexada. Para alterar uma resposta já salva, clique em Reabrir.',
    },
  },
]

export const buildPrivacyByDesignFormTutorialSteps = ({
  isEdit = false,
} = {}) => (isEdit ? [generalInfoStep, ...questionsSteps] : [generalInfoStep])
